export const listingsDataSelector = (period: string) => (state: any) => state.listingsData.data; 